<template>
  <div id="letters" class="letters">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn v-if="editIndex === -1 && (session.role() !== 'child' || letterList.length === 0)" fab absolute right class="mr-3 pf-btn-fab" :href="'#/letter/add'" to="/letter/add">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn v-else-if="editIndex > -1" fab absolute left @click="backTolisting" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="isListEmpty" class="text-center">
        <img src="static/NoLetters.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Letter(s) Found !! </b></h4>
    </v-container>
    <v-container fluid class="pt-0 pl-0" v-if="editIndex === -1">
      <draggable v-model="letterList" handle=".handle" @start="drag=true" @end="drag=false;" forceFallback= "false">
        <v-container class="-border" v-for="eachItem of letterList" :key="eachItem.id">
          <v-layout>
            <v-flex class="xs12 sm10">
              <h5 class="pf-sub-head mb-3 custom-title">
                <b>{{ eachItem.title }}</b>
                <span v-if="typeof eachItem.approved !== 'undefined' && !eachItem.approved" class="pf-pending-approval-label">Pending approval</span>
                <template v-else>
                  <v-icon size="22" v-if="eachItem.id === (session.role() === 'child' ? Child.default_letter : Account.default_letter)" color="pink lighten-3">star</v-icon>
                  <v-icon size="22" v-if="eachItem.id !== (session.role() === 'child' ? Child.default_letter : Account.default_letter)" color="grey darken-2" v-on:click="setIntroductionLetter(eachItem.id)">star_border</v-icon>
                </template>
              </h5>
            </v-flex>
            <v-flex class="xs12 sm2 text-md-right">
              <v-btn icon class="ma-0 handle" v-if="session.role() !== 'child'">
                <v-icon size="22" color="grey darken-2">open_with</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" @click="editItem(eachItem)">
                <v-icon size="22" color="grey darken-2">edit</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" v-if="session.role() !== 'child'"> <!-- Condition added later -->
                <v-icon v-if="eachItem.id === (session.role() === 'child' ? Child.default_letter : Account.default_letter)" v-on:click="deleteItem(eachItem)" size="22" color="grey darken-2">delete_outline</v-icon>
                <v-icon v-if="eachItem.id !== (session.role() === 'child' ? Child.default_letter : Account.default_letter)" v-on:click="deleteItem(eachItem)" size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex v-html="eachItem.description" class="text-xs-justify"></v-flex>
          </v-layout>
          <v-layout class="wrap pt-1 pr-1 xs12 text-xs-center">
           <!-- <v-card class="ml-4 mr-4 xs2 md2 sm2 justify-space-between" id="parentSelImagesList" >
              <v-layout class="wrap pt-1 pr-1 xs12 text-xs-center">-->
                <v-flex xs12 md2 sm2 pl-1
                        class="positionrel" v-for="imageItem of eachItem.photo" :key="imageItem.id">
                  <div>
                    <img
                      :src="`${imageItem.thumb_url}`"
                      :lazy-src="`${imageItem.thumb_url}`"
                      width="100%"
                    >
                  </div>
                </v-flex>
             <!-- </v-layout>
            </v-card>-->
          </v-layout>
          <v-divider class="mt-4"></v-divider>
        </v-container>
      </draggable>
    </v-container>
    <v-form v-else ref="formEdit">
      <v-container class="-border" >
        <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Letter Title" v-model.trim="editData.title"
                          :rules="[rules.required]"
                          class="required pr-4 pl-4" @input="changedData"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <div id="pageEditor" >
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex sm12>
                  <editor :options="editorOption" :content="content" :init="init" :api-key="apikey" v-model="editData.description" @input="changedData" />
                    <!-- <quill-editor
                      v-model="editData.description"
                      @input="changedData"
                    >
                    </quill-editor> -->
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container>
        <v-layout wrap row pl-1 pr-1>
          <v-flex class="xs12 sm6 pl-4 pf-sub-head mb-3 custom-title" wrap>Letter Images 
            <v-tooltip top>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon @click="listExistingImages()" small>
                <v-icon size="22" >image_search</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Choose from existing Albums</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon @click="addLetterImage()" small>
                <v-icon size="22" >cloud_upload</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Add new image</span>
            </v-tooltip>
            <v-btn icon small v-if="userSelectImages" @click="deleteImages(editData.id,userSelectToDeleteImages)">
             <v-icon size="22">delete_outline</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="button-container pr-3 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/letters'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
        </v-layout>
        <!-- user selected images listing area start -->
        <v-card class="ml-4 mr-4 xs2 md2 sm2 justify-space-between" id="parentSelImagesList" v-if="userSelectImages">
          <v-layout class="wrap pt-1 pr-1 xs12 text-xs-center">
            <v-flex xs12 sm6 md4 lg3 pl-1
                    class="positionrel" v-for="imageItem of userSelectedImagesThumbNew" :key="imageItem.id">
              <div>
                <img
                  :src="`${imageItem.thumb_url}`"
                  :lazy-src="`${imageItem.thumb_url}`"
                  width="100%"
                  class="image_class"
                  @click="selectImageDelete(imageItem)"
                >
                <div class="positionabs imgfade" @click="unSelectedDeleteImages(imageItem)" v-if="userDeleteImages && userSelectToDeleteImagesThumb.indexOf(imageItem.id) !== -1">
                  <v-icon size="50" class="pr-1" color="white darken-2">check_circle</v-icon>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
         <!-- <v-card class="ml-4 mr-4 xs2 md2 sm2 justify-space-between" id="parentSelImagesList" v-if="userSelectImages">
          <v-layout class="wrap pt-1 pr-1 xs12 text-xs-center">
            <v-flex v-for="imageItem of userSelectedImagesThumbNew" :key="imageItem.id" xs12 sm6 md4 lg3 pa-2>
            <v-card>
                <div
                    @click="selectImageDelete(imageItem)"
                    class="image_class"
                    :style="`background-image: url('${imageItem.thumb_url}');`"
                >
                <div class="positionabs imgfade" @click="unSelectedDeleteImages(imageItem)" v-if="userDeleteImages && userSelectToDeleteImagesThumb.indexOf(imageItem.id) !== -1">
                  <v-icon size="50" class="pr-1" color="white darken-2">check_circle</v-icon>
                </div>
                </div>
            </v-card>
            </v-flex>
          </v-layout>
        </v-card> -->
        <!-- user selected images listing area end -->
      </v-container>

       <!-- album list start -->
    <v-container grid-list-md v-if="existingImages && !photosListCard">
      <v-card class="ml-4 mr-4">
        <v-card-title class="justify-center"><span class="title font-weight-Bold custom-title">{{ this.albumList.length ? 'Albums' : 'There is no Albums avaliable'}}</span></v-card-title>
          <v-layout row wrap class="pl-4 pr-4 pb-4 xs12 text-xs-center">
            <v-flex v-for="albumItem of albumList" :key="albumItem.id" xs12 sm6 md4 lg3 pa-2 v-show="(albumItem.type === 'Normal') || (albumItem.type === 'Letter')">
            <v-card class="clickable" @click="getPhotos(albumItem.id);photosListCard = true;" >
                <div
                    class="image_class"
                    :style="`background-image: url('${albumItem.default_photo.thumb_url}');`"
                    v-if="albumItem.default_photo && albumItem.photo.length"
                ></div>
                <div class="image_class" :style="`background-image: url(${newAlbum.src});`" v-else></div>
                <v-flex class="pl-1 pr-1 mb-0">
                <h5
                    id="albumName"
                    class="pa-1 title-display"
                >
                <div>
                        <span v-if="albumItem.name">{{ albumItem.name }}</span>
                        <span v-else>Untitled</span>
                    </div>
                </h5>
                </v-flex>
            </v-card>
            </v-flex>
      </v-layout>
      </v-card>
    </v-container>
    <!-- album list end -->
    <v-container grid-list-md v-if="photoList.length > 0 && photosListCard">
        <v-card class="ml-4 mr-4">
         <v-card-title class="justify-center">
            <v-btn fab absolute left @click="photosListCard = false" class="ml-3 pf-btn-fab backToAlbum">
            <v-icon>arrow_back</v-icon>
          </v-btn>
             <span class="title font-weight-Bold custom-title">{{`PHOTOS / ${album.name}`}}</span></v-card-title>
          <v-layout row wrap class="pa-4 xs12 text-xs-center">
            <v-flex v-for="(photo, i) in photoList" :key="i" xs12 sm6 md4 lg3 pa-2 >
            <v-card flat tile v-if="photo" class="positionrel">
            <div class="image_class " :key="photo.id" :style="`background-image: url('${photo.thumb_url}');`" :imgid="photo.id" @click="selectedImages(photo)"></div>
            <div class="positionabs imgfade" @click="unSelectedImages(photo.id, photo.thumb_url, photo)" v-if="userSelectImages && userSelectedImages.indexOf(photo.id) !== -1">
                <v-icon size="50" class="pr-1 pl-3" color="white darken-2">check_circle</v-icon>
            </div>
            </v-card>
            </v-flex>
        </v-layout>
        </v-card>
    </v-container>

      <v-container>
        <v-layout class="pt-5">
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store config */
import swal from 'sweetalert2';
import { getCollection, update, remove, sortList, updateSortList, getOne, uploadFile } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
// import { quillEditor } from 'vue-quill-editor';
import Editor from '@tinymce/tinymce-vue';
import goTo from 'vuetify/lib/components/Vuetify/goTo';

// This lists the letters for the parent
export default {
  name: 'ListLetter',
  components: {
    draggable,
    // quillEditor,
    Editor
  },
  data: (vm) => ({
    entity: 'Letter',
    roleEntity: 'Account',
    isListEmpty: false,
    config: config,
    dialog: false,
    currentDeleteItem: null,
    editIndex: -1,
    editData: {},
    selectedData: false,
    photosDetails: [],
    tab: null,
    existingImages: false,
    direction: 'bottom',
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: true,
    right: true,
    bottom: false,
    left: false,
    transition: 'slide-y-reverse-transition',
    // albumList: [],
    photoList: [],
    absolute: true,
    overlay: false,
    userSelectedImages: [],
    userSelectedImagesThumb: [],
    userSelectImages: false,
    length: 3,
    window: 0,
    userSelectedImagesThumbNew: [],
    userSelectedImagesThumbNewExisting: [],
    userDeleteImages: false,
    userSelectToDeleteImages: [],
    userSelectToDeleteImagesThumb: [],
    s3Domain: 'testpfvue',
    rules: {
      required: value => !!value || 'Field is required.',
    },
    photosListCard: false,
    uploadToLetterAlbum: false,
    content: '',
    editorOption: {
      placeholder: 'Add Letter Content Here..',
    },
    apikey: config.tinymceEditorKey,
    init: {
      height: 500,
      selector: 'blogTextEditor',
      placeholder: 'Add letter content here',
      paste_data_images: true,
      file_picker_types: 'image',
      images_upload_handler: function (blobInfo, success, failure) {
        let postUrl = 'File';
        let extraParams = {
          type: 'Letter'
        };
        extraParams[vm.roleEntity.toLowerCase()] = session.user().human[vm.roleEntity.toLowerCase()].id;

        uploadFile(postUrl, blobInfo.blob(), 'POST', extraParams)
          .then(function (res) {
            success(config.uploadPath + res.$data.webPath);
          })
          .catch(function (err) {
            failure('HTTP Error: ' + err.message);
          });
      },
      menubar: true,
      plugins: ['advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount emoticons'],
      toolbar:
           'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview | insertfile image media template link anchor codesample | ltr rtl'
    }
  }),
  computed: {
    ...mapGetters(['Album', 'AlbumPhoto', 'Account', 'Child', 'Agency']),
    letterList: {
      get () {
        return store.state.Letter;
      },
      set (value) {
        updateSortList(this.entity, value, this.roleEntity, session.getSession().adminUser ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : 'Me');
        store.commit('setLetter', value);
      }
    },
    albumList: {
      get () {
        return store.state.Album.filter(item => (item.photo.length > 0));
      },
      set (value) {
        store.commit('setAlbum', value);
      }
    }
  },
  watch: {

  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    this.sessionRole = session.role();
    this.initialize();
  },
  mounted () {
    
    window.getApp.$on('NEW_LETTER_PHOTO', messageEvent => {
      console.log('------------>>>>>>>', 'Letter Photo list', messageEvent);
      if (messageEvent.data) {
        let albumId = messageEvent.data.album;
        let newImages = messageEvent.data;
        let existingImage = false;
        window.getApp.$emit('CHOOSE_ADDED_PHOTO', this.editIndex, newImages);
        this.selectedData = true;
        if (!this.AlbumPhoto[albumId]) {
          this.getPhotos(albumId);
          if (this.AlbumPhoto[albumId] === undefined) {
            this.AlbumPhoto[albumId] = [];
          }
        }
        if (this.AlbumPhoto[albumId].length > 0) {
          if (this.AlbumPhoto[albumId].find(item => item.id === newImages.id)) {
            existingImage = true;
          }
          if (!existingImage) {
            this.AlbumPhoto[albumId].push(newImages);
          }
        }
        else {
          this.AlbumPhoto[albumId].push(newImages);
        }
        console.log('mediator this.AlbumPhoto[albumId]', this.AlbumPhoto[albumId]);
        let newAlbumPhoto = {
          photo: newImages.id,
          sort_no: 0
        };
        const albumIndex = this.Album.findIndex(item => item.id === albumId);
        this.Album[albumIndex].photo.push(newAlbumPhoto);
        
      }
    });
    window.getApp.$on('CHOOSE_ADDED_PHOTO', (editFlag, data) => {
      if (editFlag > -1) {
        this.selectedImages(data);
      }
    });
  },
  methods: {
    // @vuese
    // Used to go back to the letter listing page
    backTolisting () {
      this.editIndex = -1;
      this.selectedData = false;
      this.existingImages = false;
      this.userSelectedImagesThumbNew = [...this.userSelectedImagesThumbNewExisting];
      window.getApp.$emit('pageSubHeader', '');
    },
    // @vuese
    // Used to fetch the letter list if not exists
    async initialize () {
      let sessionUser = session.getSession();
      let where = {};
      if (sessionUser.adminUser) {
        where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
      }
      if (!this.letterList.length) {
        let { error, data } = await getCollection(this.entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.letterList = sortList(this.entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
          } else {
            this.isListEmpty = true;
          }
        }
      }
    },
    // @vuese
    // Used to setup the edit letter form
    // @arg The letter object to be edited
    editItem (item) {
      this.userSelectToDeleteImagesThumb = [];
      this.userSelectedImagesThumb = [];
      this.userSelectedImagesThumbNewExisting = [];
      this.userSelectedImagesThumbNew = [];
      this.userSelectedImagesObject = [];
      this.userSelectToDeleteImages = [];
      this.userSelectToDeleteImagesThumb = [];
      this.userSelectImages = false;
      this.existingImages = false;
      this.photosListCard = false;
      this.photoList = [];
      // Fired when the letter is in edit mode
      // @arg The page mode - Edit or Add
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.getAlbums();
      this.editIndex = this.letterList.indexOf(item);
      this.editData = Object.assign({}, item);
      if (this.editData.photo.length > 0) {
        // this.userSelectedImagesThumb = this.editData.images;
        this.userSelectedImagesThumbNew = [...this.editData.photo];
        this.userSelectedImagesThumbNewExisting = [...this.userSelectedImagesThumbNew];
        for (let i = 0; i < this.editData.photo.length; i++) {
          this.selectedImages(this.editData.photo[i]);
          this.userSelectedImagesThumb.push(this.editData.photo[i].id);
        }
        // this.selectedImages(this.editData.images, this.editData.images.thumb_url)
      }
    },
    // @vuese
    // Used to show the edit form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide the edit form buttons
    hideButtons () {
      this.selectedData = false;
    },
    // @vuese
    // Called when the introduction letter selected to be deleted
    deleteIntroLetter () {
      swal.fire({
        type: 'warning',
        title: 'Introduction Letter',
        text: 'Please set another letter as introduction to delete this!',
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      });
    },
    // @vuese
    // Used to delete the selected letter
    // @arg The letter object to be deleted
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Something went wrong, please try again.'
              };
            } else {
              const index = this.letterList.indexOf(item);
              this.letterList.splice(index, 1);
              if (this.letterList.length === 0) this.isListEmpty = true;
              let deletedLetterItem = this[this.roleEntity].letter.find(letter => letter.letter === item.id);
              this[this.roleEntity].letter.splice(this[this.roleEntity].letter.indexOf(deletedLetterItem), 1);
              swal.fire(
                'Deleted!',
                'The letter with title "' + item.title + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    // @vuese
    // Used to save the edited letter
    async save () {
      this.selectedData = false;
      if (!this.editData.title.length) {
        this.selectedData = true;
        swal.fire({
          type: 'warning',
          title: 'Title is required.',
          text: 'Please add title before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      }
      else if (!this.editData.description.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        this.selectedData = true;
        swal.fire({
          type: 'warning',
          title: 'Content is required.',
          text: 'Please add content before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      } else {
        if (this.$refs.formEdit.validate() && this.editIndex > -1) {
          this.editData.photo = [...this.userSelectedImagesThumbNew];
          let { error, data, status } = await update(this.entity, this.editData, this.editData.id);
          if (error) {
            this.selectedData = true;
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Something went wrong, please try again.'
            };
          } else {
            this.letterList[this.editIndex] = data;
            this.existingImages = false;
            swal.fire({
              type: 'success',
              title: 'Letter updated successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.editIndex = -1;
                window.getApp.$emit('pageSubHeader', '');
              }
            });
          }
        }
      }
    },
    // @vuese
    // Used to set the introduction letter
    // $arg The letter ID that to be set as introduction letter
    async setIntroductionLetter (key) {
      let deleteEntity = '';
      if (this.sessionRole === 'agency') {
        this.Agency.default_letter = key;
        this.roleData = this.Agency;
        deleteEntity = `Agency`;
      } else {
        this[this.roleEntity].default_letter = key;
        this.roleData = this[this.roleEntity];
        this.roleData.updated_from = 'letters';
        deleteEntity = this.roleEntity;
      }

      let entity = this.roleEntity;
      let entityId = deleteEntity === this.roleEntity ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : session.getSession().user.human.agency;
      let { error, data, status } = await update(deleteEntity, this.roleData, session.getSession().adminUser ? entityId : 'Me');
      if (error) {
        console.log('error', error);
      } else {
        this.loading = false;
        swal.fire({
          type: 'success',
          title: 'Introduction letter set successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            // this.selectedData = false;
          }
        });
      }
    },
    // @vuese
    // Used to fetch albums if not exists already
    async getAlbums () {
      let sessionUser = session.getSession();
      let where = {};
      if (sessionUser.adminUser) {
        where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
      }
      if (!this.albumList.length || this.uploadToLetterAlbum) {
        let entity = 'Album';
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.albumList = sortList(entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity].id : 'Me');
          }
        }
        this.uploadToLetterAlbum = false;
      }
    },
    // @vuese
    // Used to fetch the photos of a particular album
    // @arg The album ID
    async getPhotos (albumId) {
      this.albumId = albumId;
      if (!this.AlbumPhoto[this.albumId]) {
        let { error, data } = await getOne('Album', this.albumId);
        if (error) {
          console.log('error', error);
        } else {
          const photos = [];
          for (let i = 0; i < data.photo.length; i++) {
            photos.push(data.photo[i].photo);
            data.photo[i].photo = data.photo[i].photo.id;
          }
          this.album = data;
          this.AlbumPhoto[this.albumId] = photos;
          this.photoList = sortList('Photo', this.AlbumPhoto[this.albumId], 'Album', this.albumId, this.album.photo);
          // this.albumName = data.name;
          // this.defaultPhoto = data.default_photo;
        }
      } else {
        const album = this.Album.find(item => item.id === this.albumId);
        this.album = { ...album };
        this.photoList = sortList('Photo', this.AlbumPhoto[this.albumId], 'Album', this.albumId);
        // this.albumName = this.album.name;
        // this.defaultPhoto = this.album.default_photo;
      }
    },
    // @vuese
    // Used to list the album photos to search and add to the letter
    listExistingImages () {
      this.existingImages = true;
      this.selectedData = true;
      goTo(1199, { duration: 300, offset: 0, easing: 'easeInOutCubic' });
    },
    // @vuese
    // Used to add the selected photo(s) to the letter
    // @arg Selected photo ID, Thumb URL of the photo, The photo object
    selectedImages (photo) {
      this.userSelectImages = true;
      if (this.userSelectedImagesThumbNew.indexOf(photo) === -1) {
        this.userSelectedImagesThumbNew.push(photo);
        this.userSelectedImagesThumb.push(photo.id);
      }
      goTo(1099, { duration: 300, offset: 0, easing: 'easeInOutCubic' });
    },
    // @vuese
    // Used to remove the selected photo(s) from the letter
    // @arg Selected photo ID, Thumb URL of the photo, The photo object
    unSelectedImages (photo) {
      if (this.userSelectedImagesThumbNew.length <= 1) this.userSelectImages = false;
      if (this.userSelectedImagesThumb.indexOf(photo.id) !== -1) {
        this.userSelectedImagesThumbNew.splice(this.userSelectedImagesThumb.indexOf(photo.id), 1);
        this.userSelectedImagesThumb.splice(this.userSelectedImagesThumb.indexOf(photo.id), 1);
      }
    },
    // @vuese
    // Called when user checked the image
    // @arg The checked photo object
    selectImageDelete (photo) {
      this.userDeleteImages = true;
      if (this.userSelectToDeleteImages.indexOf(photo) === -1) {
        this.userSelectToDeleteImages.push(photo);
        this.userSelectToDeleteImagesThumb.push(photo.id);
      }
    },
    // @vuese
    // Called when user un-checked the image
    // @arg The un-checked photo object
    unSelectedDeleteImages (photo) {
      if (this.userSelectToDeleteImages.length <= 1) this.userDeleteImages = false;
      if (this.userSelectToDeleteImagesThumb.indexOf(photo.id) !== -1) {
        this.userSelectToDeleteImages.splice(this.userSelectToDeleteImagesThumb.indexOf(photo.id), 1);
        this.userSelectToDeleteImagesThumb.splice(this.userSelectToDeleteImagesThumb.indexOf(photo.id), 1);
      }
    },
    // @vuese
    // Used to remove the selected images
    // @arg The letter ID, The selected photos array
    deleteImages (letterID, userSelectToDeleteImagesArr) {
      this.selectedData = true;
      for (let p = 0; p < userSelectToDeleteImagesArr.length; p++) {
        if (this.userSelectedImagesThumbNew.indexOf(userSelectToDeleteImagesArr[p]) !== -1) {
          this.userSelectedImagesThumbNew.splice(this.userSelectedImagesThumb.indexOf(userSelectToDeleteImagesArr[p].id), 1);
          this.userSelectedImagesThumb.splice(this.userSelectedImagesThumb.indexOf(userSelectToDeleteImagesArr[p].id), 1);
        }
      }
      if (this.userSelectedImagesThumbNew.length < 1) this.userSelectImages = false;
      this.userSelectToDeleteImagesThumb = [];
      this.userSelectToDeleteImages = [];
    },
    // @vuese
    // Used to upload new photos to the letter
    addLetterImage () {
      const client = global.filestack.init(config.filestack.client);
      const humanId = session.user().human.id;
      const albumId = this[this.roleEntity].letter_album;
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 20,
        accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
        uploadInBackground: false,
        storeTo: {
          location: 'S3',
          path: '/' + config.s3Domain + '/' + humanId + '/album/' + albumId + '/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          return { name: filename + '_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: (response) => {
          // After uploading
          this.uploadToLetterAlbum = true;
          this.photosListCard = false;
          this.existingImages = false;
          this.getAlbums();
          if (this[this.roleEntity].letter_album) {
            delete this.AlbumPhoto[this[this.roleEntity].letter_album];
            this.getPhotos(this[this.roleEntity].letter_album);
          }
          swal.fire({
            type: 'success',
            title: 'Letter Images',
            text: 'Click existing album icon to see the uploaded image(s) in LETTER IMAGES album.',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
        }
      };
      client.picker(options).open();
    }
  }
};
</script>

<style lang="stylus" scoped>
.clickable {
  cursor: pointer;
}
.custom-title {
  color: #4b4b4b;
  font-size: 18px !important;
}

.backToAlbum {
    left: 65px;
    margin-top: 6px;
}
</style>




// WEBPACK FOOTER //
// src/pages/Letters/list.vue